// The medicines picked for ordering on the low-stock screen. Kept in
// localStorage so the selection survives navigation, refresh and tab switches;
// it is only emptied once an order containing those medicines is created.
const CART_KEY = 'inventory-medicine-cart';

export const readCart = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
    return Array.isArray(ids) ? ids.filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const writeCart = (ids) => {
  try {
    if (ids?.length) localStorage.setItem(CART_KEY, JSON.stringify(ids));
    else localStorage.removeItem(CART_KEY);
  } catch {
    // Storage unavailable (private mode etc.) — the cart just won't persist.
  }
};

// Drop the medicines that just went into an order; anything else stays.
export const removeFromCart = (orderedIds) => {
  const ordered = new Set(orderedIds);
  writeCart(readCart().filter((id) => !ordered.has(id)));
};
